<template>
	<div class="sidebar">
		<el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#ffffff"
			text-color="#000" active-text-color="#20a0ff" unique-opened router>
			<el-submenu index="1">
				<template v-slot:title>
					<i class="el-icon-wangzhan"></i>
					<span>网站管理</span>
				</template>
				<el-submenu v-for="item1 in items" :index="item1.id" :key="item1.id">
					<template v-slot:title>
						<i :class="item1.icon"></i>
						<span>{{item1.title}}</span>
					</template>
					<el-menu-item v-for="item2 in item1.itemsSon" :index="item2.index" :key="item2.index">
						<i :class="item2.icon"></i>
						{{ item2.title }}
					</el-menu-item>
				</el-submenu>
			</el-submenu>
			<el-submenu index="2" v-if="isshow">
				<template v-slot:title>
					<i class="el-icon-gongzhonghao"></i>
					<span>公众号管理</span>
				</template>
				<el-submenu index="2-1">
					<template v-slot:title>
						<i class="el-icon-pingji"></i>
						<span>公众号发布管理</span>
					</template>
					<el-menu-item index="cgList">
						<i class="el-icon-pingji"></i>
						新闻群发
					</el-menu-item>
					<!-- <el-menu-item index="qfList">
						<i class="el-icon-pingji"></i>
						群发管理
					</el-menu-item> -->
				</el-submenu>
				
				
				
				<!-- <el-submenu  :index="item1.id" :key="item1.id">
					<template v-slot:title>
						<i :class="item1.icon"></i>
						<span>{{item1.title}}</span>
					</template>
				</el-submenu>
				<el-submenu v-for="item1 in items" :index="item1.id" :key="item1.id">
					<template v-slot:title>
						<i :class="item1.icon"></i>
						<span>{{item1.title}}</span>
					</template>
				</el-submenu> -->
			</el-submenu>
		</el-menu>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		data() {
			return {
				token: localStorage.getItem('access_token'),
				items: [],
				RoleId: localStorage.getItem('RoleId'),
				isshow:false
			};
		},
		computed: {
			
			onRoutes() {
				return this.$route.path.replace("/", "");
			},
			collapse() {
				return this.$store.state.collapse
			}
		},
		mounted() {
			this.GetDeviceType();
		},
		created() {
			if(this.RoleId=='a348ae2d-fb9c-4675-856c-936aa6c103c5'||this.RoleId=='be4e45c7-03cc-45ee-8f00-49c3665819ca'||this.RoleId=='a591fe1e-7da8-4124-8912-b5af5282d57a'){
				this.isshow = false
			}else{
				this.isshow = true
			}
		},
		methods: {
			GetDeviceType() {
				const access_token = this.token;
				axios({
					method: 'GET',
					url: this.$store.state.pcurl + "GetLoginInfo",
					headers: {
						"Authorization": "bearer " + access_token + ""
					},
				}).then((res) => {
					if (res.data.Status == 200) {
						//  获取用户权限
						let RoleId = localStorage.getItem("RoleId");
						if (RoleId == "5d59a2fe-5f94-4671-8394-e2fefdb6d2ed") {
							// 管理员
							return this.items = [{
									id: 0,
									icon: "el-icon-xitongguanli",
									title: "系统管理",
									itemsSon: [{
											index: "person",
											title: "角色管理",
											icon: "el-icon-navicon-jsgl",
										},
										{
											index: "user",
											title: "系统用户管理",
											icon: "el-icon-user",
										}
									]
								},
								{
									id: 1,
									icon: "el-icon-neirongguanli",
									title: "内容发布管理",
									itemsSon: [{
											index: "newsActive",
											title: "新闻活动",
											icon: "el-icon-huodong",
										},
										{
											index: "companyIntr",
											title: "公司介绍",
											icon: "el-icon-jieshao",
										},
										{
											index: "fwxy",
											title: "服务协议",
											icon: "el-icon-fuwuxieyi",
										},
										{
											index: "splc",
											title: "送评流程",
											icon: "el-icon-liucheng",
										},
										{
											index: "pjfw",
											title: "评级范围",
											icon: "el-icon-fuwufanwei",
										},
										{
											index: "pjbz",
											title: "评级标准",
											icon: "el-icon-biaozhun",
										},
										{
											index: "pjfy",
											title: "评级费用",
											icon: "el-icon-zhangdanfeiyongmingxi",
										},
										{
											index: "lunbo",
											title: "轮播管理",
											icon: "el-icon-lunbotu1",
										}
									]
								}
							]
						} else if (RoleId == "002860b9-6844-4982-9ac4-5453c9cdea3c") {
							//总评
							return this.items = [{
									id: 2,
									title: "客户信息管理",
									icon: "el-icon-kehuxinxiguanli",
									itemsSon: [{
											icon: "el-icon-huiyuan",
											index: "member",
											title: "会员列表"
										},
										{
											icon: "el-icon-document-checked",
											index: "distributor",
											title: "经销商列表"
										}
									]
								},
								{
									id: 3,
									title: "评级分类管理",
									icon: "el-icon-shenduxuexi_fenlei_rnnfenlei",
									itemsSon: [{
										icon: "el-icon-fenlei",
										index: "classificationList",
										title: "分类列表"
									}, {
										icon: "el-icon-xilie",
										index: "seriesList",
										title: "系列列表"
									}, ]
								},
								{
									id: 4,
									title: "评级管理",
									icon: "el-icon-huiyuanjibiechuli",
									itemsSon: [{
											icon: "el-icon-pingji",
											index: "pingjiList",
											title: "订单管理"
										}, {
											icon: "el-icon-pingji",
											index: "goodsList",
											title: "商品管理"
										},
										{
											icon: "el-icon-pingji",
											index: "Ratingpool",
											title: "评级池"
										},
										{
											icon: "el-icon-pingji",
											index: "completeRating",
											title: "完成评级"
										}
									]
								},
								{
									id: 5,
									title: "打印管理",
									icon: "el-icon-dayin",
									itemsSon: [{
										icon: "el-icon-pingji",
										index: "Orderprinting",
										title: "评级商品打印"
									}]
								},
								{
									id: 6,
									title: "数据统计",
									icon: "el-icon-shujutongji",
									itemsSon: [{
										icon: "el-icon-pingji",
										index: "dataStatistics",
										title: "评级数据统计"
									}]
								},
							]
						} else if (RoleId == "a348ae2d-fb9c-4675-856c-936aa6c103c5") {
							//评级师
							return this.items = [{
								id: 4,
								title: "评级管理",
								icon: "el-icon-huiyuanjibiechuli",
								itemsSon: [{
										icon: "el-icon-pingji",
										index: "Ratingpool",
										title: "评级池"
									},
									{
										icon: "el-icon-pingji",
										index: "completeRating",
										title: "完成评级"
									}
								],
							}]
						} else if (RoleId == "2d7a48e5-503b-463e-878a-361e1b175551") {
							//客服
							return this.items = [{
									id: 1,
									icon: "el-icon-neirongguanli",
									title: "内容发布管理",
									itemsSon: [{
											index: "newsActive",
											title: "新闻活动",
											icon: "el-icon-huodong",
										},
										{
											index: "companyIntr",
											title: "公司介绍",
											icon: "el-icon-jieshao",
										},
										{
											index: "fwxy",
											title: "服务协议",
											icon: "el-icon-fuwuxieyi",
										},
										{
											index: "splc",
											title: "送评流程",
											icon: "el-icon-liucheng",
										},
										{
											index: "pjfw",
											title: "评级范围",
											icon: "el-icon-fuwufanwei",
										},
										{
											index: "pjbz",
											title: "评级标准",
											icon: "el-icon-biaozhun",
										},
										{
											index: "pjfy",
											title: "评级费用",
											icon: "el-icon-zhangdanfeiyongmingxi",
										},
										{
											index: "lunbo",
											title: "轮播管理",
											icon: "el-icon-lunbotu1",
										}
									]
								}, {
									id: 4,
									title: "评级管理",
									icon: "el-icon-huiyuanjibiechuli",
									itemsSon: [{
										icon: "el-icon-pingji",
										index: "pingjiList",
										title: "订单管理"
									}, {
										icon: "el-icon-pingji",
										index: "goodsList",
										title: "商品管理"
									}]
								},
								{
									id: 5,
									title: "数据统计",
									icon: "el-icon-shujutongji",
									itemsSon: [{
										icon: "el-icon-pingji",
										index: "dataStatistics",
										title: "评级数据统计"
									}]
								},
							]
						} else if (RoleId == "a591fe1e-7da8-4124-8912-b5af5282d57a") {
							//经销商
							return this.items = [{
								id: 4,
								title: "评级管理",
								icon: "el-icon-huiyuanjibiechuli",
								itemsSon: [{
									icon: "el-icon-pingji",
									index: "pingjiList",
									title: "订单管理"
								}, {
									icon: "el-icon-pingji",
									index: "goodsList",
									title: "商品管理"
								}]
							}]
						}
					} else {
						this.$message.error('获取角色信息失败');
					}
				}).catch(() => {
					localStorage.clear();
					this.$router.push("/login");
					this.$message.error('登录已过期,请重新登录');
				})
			}
		}
	};
</script>

<style scoped>
	.sidebar {
		display: block;
		position: absolute;
		left: 0;
		top: 70px;
		bottom: 0;
		overflow-y: scroll;
	}

	.sidebar::-webkit-scrollbar {
		width: 0;
	}

	.sidebar-el-menu:not(.el-menu--collapse) {
		width: 250px;
	}

	.sidebar>ul {
		height: 100%;
	}
</style>
